import React, { useLayoutEffect, useRef, useState } from "react";
import { Container } from "react-bootstrap";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
// import "./IndustriesServed.css";


import pack01 from "../assets/img/industries/Retail.jpg"
import pack02 from "../assets/img/industries/Food-Beve.jpg"
import pack03 from "../assets/img/industries/Hospitality.jpg"
import pack04 from "../assets/img/industries/Healthcare.jpg"
import pack05 from "../assets/img/industries/Manufacturing.jpg"
import pack06 from "../assets/img/industries/construction.jpg"
import pack07 from "../assets/img/industries/Logistic.png"
import pack08 from "../assets/img/industries/Industrial.jpg.jpeg"



gsap.registerPlugin(ScrollTrigger);

const industries = [
  {
    number: "01",
    title: "Retail",
    category: "RETAIL & SHOPPING",
    description:
      "Sustainable shopping bags and branded packaging designed for modern retail environments.",
    image: pack01,
  },
  {
    number: "02",
    title: "Food & Beverage",
    category: "FOOD / TAKEAWAY / DELIVERY",
    description:
      "Food-safe packaging solutions for restaurants, cafés, bakeries, takeaway and delivery.",
    image: pack02,
  },
  {
    number: "03",
    title: "Hospitality",
    category: "HOTELS / RESORTS / EVENTS",
    description:
      "Packaging solutions supporting hotels, resorts, restaurants, events and guest experiences.",
    image: pack03,
  },
  {
    number: "04",
    title: "Healthcare",
    category: "PHARMACY / HEALTHCARE",
    description:
      "Reliable packaging solutions for pharmacies, healthcare facilities and related applications.",
    image: pack04,
  }
  // {
  //   number: "05",
  //   title: "Grocery and Q Commerce",
  //   category: "PRODUCTION / INDUSTRIAL",
  //   description:
  //     "Packaging solutions built around operational efficiency, durability and production requirements.",
  //   image: pack05,
  // },
  // {
  //   number: "06",
  //   title: "Construction",
  //   category: "CONSTRUCTION / INFRASTRUCTURE",
  //   description:
  //     "Practical material and packaging solutions supporting construction and infrastructure businesses.",
  //   image: pack06,
  // },
  // {
  //   number: "07",
  //   title: "Logistics",
  //   category: "SUPPLY CHAIN / DISTRIBUTION",
  //   description:
  //     "Packaging solutions designed for movement, handling, storage and distribution.",
  //   image: pack07,
  // },
  // {
  //   number: "08",
  //   title: "Industrial",
  //   category: "B2B / INDUSTRIAL / CUSTOM",
  //   description:
  //     "Custom packaging and material solutions for demanding industrial applications.",
  //   image: pack08,
  // },
];

function IndustriesServed() {
  const sectionRef = useRef(null);
  const imageRef = useRef(null);
  const imageWrapperRef = useRef(null);
  const contentRef = useRef(null);

  const [activeIndex, setActiveIndex] = useState(0);

  const activeIndustry = industries[activeIndex];

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 75%",
        },
      });

      tl.from(".industries-eyebrow", {
        y: 25,
        opacity: 0,
        duration: 0.7,
        ease: "power3.out",
      })
        .from(
          ".industries-heading-line",
          {
            yPercent: 110,
            opacity: 0,
            duration: 0.9,
            stagger: 0.12,
            ease: "power4.out",
          },
          "-=0.3"
        )
        .from(
          ".industries-intro",
          {
            y: 25,
            opacity: 0,
            duration: 0.7,
          },
          "-=0.5"
        )
        .from(
          ".industry-image-wrapper",
          {
            scale: 0.92,
            opacity: 0,
            duration: 1,
            ease: "power3.out",
          },
          "-=0.4"
        )
        .from(
          ".industry-row",
          {
            x: 35,
            opacity: 0,
            duration: 0.6,
            stagger: 0.07,
            ease: "power3.out",
          },
          "-=0.6"
        );

      // Slow image movement
      gsap.to(".industry-image", {
        scale: 1.08,
        duration: 8,
        repeat: -1,
        yoyo: true,
        ease: "sine.inOut",
      });

      // Floating decorative circle
      gsap.to(".industry-floating-circle", {
        y: -18,
        x: 10,
        duration: 3,
        repeat: -1,
        yoyo: true,
        ease: "sine.inOut",
      });
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  const changeIndustry = (index) => {
    if (index === activeIndex) return;

    const image = imageRef.current;
    const content = contentRef.current;

    const tl = gsap.timeline({
      onComplete: () => {
        setActiveIndex(index);
      },
    });

    tl.to(
      [image, content],
      {
        opacity: 0,
        x: 20,
        duration: 0.25,
        ease: "power2.in",
      }
    );
  };

  useLayoutEffect(() => {
    if (!imageRef.current || !contentRef.current) return;

    const tl = gsap.timeline();

    tl.fromTo(
      imageRef.current,
      {
        opacity: 0,
        scale: 1.08,
        x: -20,
      },
      {
        opacity: 1,
        scale: 1,
        x: 0,
        duration: 0.65,
        ease: "power3.out",
      }
    );

    tl.fromTo(
      contentRef.current,
      {
        opacity: 0,
        y: 15,
      },
      {
        opacity: 1,
        y: 0,
        duration: 0.45,
        ease: "power3.out",
      },
      "-=0.4"
    );

    return () => tl.kill();
  }, [activeIndex]);

  return (
    <div
      ref={sectionRef}
      className="industries-section"
      id="industries"
    >
      <div className="industry-bg-grid" />
      <Container className="py-lg-5 px-lg-5" fluid>
        <div className="industries-header">
          <div className="industries-heading-grid">
            <h2 className="industries-heading">
              <span className="heading-mask">
                <span className="industries-heading-line">
                  Packaging that
                </span>
              </span>

              <span className="heading-mask">
                <span className="industries-heading-line green-heading">
                  moves industries.
                </span>
              </span>
            </h2>

            <p className="industries-intro">
              From retail and hospitality to food service and
              industrial applications, our packaging solutions
              adapt to the businesses we serve.
            </p>
          </div>
        </div>

        <div className="industry-showcase">
          <div
            ref={imageWrapperRef}
            className="industry-image-wrapper"
          >
            <div className="industry-image-overlay" />

            <img
              ref={imageRef}
              className="industry-image"
              src={activeIndustry.image}
              alt={activeIndustry.title}
              onError={(e) => {
                e.currentTarget.style.display = "none";
                e.currentTarget.parentElement.classList.add(
                  "image-fallback"
                );
              }}
            />

            <div className="industry-image-fallback">
              <span>MEF</span>
              <small>{activeIndustry.title}</small>
            </div>

            <div
              ref={contentRef}
              className="industry-image-content"
            >
              <div className="image-top-meta">
                <span></span>
                <span>0{activeIndex + 1} INDUSTRIES</span>
              </div>

              <div className="image-bottom-content">
                <span>{activeIndustry.category}</span>

                <h3>{activeIndustry.title}</h3>

                <p>{activeIndustry.description}</p>
              </div>
            </div>

       
            <div className="industry-floating-circle">
              {/* <span>EXPLORE</span> */}
              <strong><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="24" height="24">
  <path d="M14 50L50 14" fill="none" stroke="currentColor" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M27 14H50V37" fill="none" stroke="currentColor" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>
</svg></strong>
            </div>
          </div>

      
          <div className="industry-list">
            {industries.map((industry, index) => (
              <button
                type="button"
                key={industry.number}
                className={`industry-row ${
                  activeIndex === index ? "active" : ""
                }`}
                onMouseEnter={() => changeIndustry(index)}
                onFocus={() => changeIndustry(index)}
                onClick={() => changeIndustry(index)}
              >
                <span className="industry-number">
                  {/* {industry.number} */}
                </span>

                <span className="industry-title">
                  {industry.title}
                </span>

                <span className="industry-arrow">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="24" height="24">
  <path d="M14 50L50 14" fill="none" stroke="currentColor" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M27 14H50V37" fill="none" stroke="currentColor" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
                </span>

                <span className="industry-active-bar" />
              </button>
            ))}
          </div>
        </div>

      </Container>
     
    </div>
  );
}

export default IndustriesServed;